(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  const updateVonjonHeader = () => {
    document.querySelectorAll('.site-header').forEach((header) => {
      header.classList.toggle('is-scrolled', window.scrollY > 80);
    });
  };

  updateVonjonHeader();

  if (!window.vonjonHeaderScrollBound) {
    window.addEventListener('scroll', updateVonjonHeader, { passive: true });
    document.addEventListener('shopify:section:load', updateVonjonHeader);
    window.vonjonHeaderScrollBound = true;
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const openButton = event.target.closest('[data-vj-size-guide-open]');
    if (openButton) {
      const dialogId = openButton.getAttribute('aria-controls');
      const dialog = document.getElementById(dialogId);

      if (dialog instanceof HTMLDialogElement && !dialog.open) {
        dialog.showModal();
      }

      return;
    }

    const countryButton = event.target.closest('[data-vj-country]');
    if (countryButton) {
      const guide = countryButton.closest('[data-vj-size-guide]');
      const country = countryButton.getAttribute('data-vj-country');

      if (!guide || !country) return;

      guide.querySelectorAll('[data-vj-country]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === countryButton));
      });

      guide.querySelectorAll('[data-vj-country-row]').forEach((row) => {
        row.hidden = row.getAttribute('data-vj-country-row') !== country;
      });

      return;
    }

    const unitButton = event.target.closest('[data-vj-unit]');
    if (unitButton) {
      const guide = unitButton.closest('[data-vj-size-guide]');
      const unit = unitButton.getAttribute('data-vj-unit');

      if (!guide || !unit) return;

      guide.querySelectorAll('[data-vj-unit]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button === unitButton));
      });

      guide.querySelectorAll('[data-vj-unit-table]').forEach((table) => {
        table.hidden = table.getAttribute('data-vj-unit-table') !== unit;
      });

      return;
    }

    const dialog = event.target.closest('dialog.vj-size-guide-modal');
    if (dialog && event.target === dialog) {
      dialog.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vj-cart-drawer"]) return;
  try {
    
  if (!window.vjCartDrawerController) {
    class VjCartDrawerController {
      constructor() {
        this.busy = false;
        this.opener = null;
        this.boundDialogs = new WeakSet();

        document.addEventListener('submit', (event) => this.onSubmit(event));
        document.addEventListener('click', (event) => this.onClick(event));
        document.addEventListener('shopify:section:load', () => this.sync());

        window.addEventListener('pageshow', (event) => {
          if (event.persisted && this.root) {
            this.setBusy(false);
            this.refresh().catch(() => {});
          }
        });

        this.sync();
      }

      get root() {
        return document.querySelector('[data-vj-cart-root]');
      }

      get dialog() {
        return this.root?.querySelector('[data-vj-cart-dialog]');
      }

      get available() {
        return Boolean(this.dialog && typeof this.dialog.showModal === 'function');
      }

      get cartUrl() {
        return this.root?.dataset.cartUrl || '/cart';
      }

      endpoint(path) {
        const root = this.root?.dataset.rootUrl || window.Shopify?.routes?.root || '/';
        return root.replace(/\/?$/, '/') + path;
      }

      sync() {
        const dialog = this.dialog;
        if (!dialog) return;

        this.syncHeader();

        if (this.boundDialogs.has(dialog)) return;
        this.boundDialogs.add(dialog);

        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) this.close();
        });

        dialog.addEventListener('close', () => {
          this.syncHeader();

          if (this.opener?.isConnected) {
            this.opener.focus({ preventScroll: true });
          }
        });
      }

      syncHeader() {
        const root = this.root;
        if (!root) return;

        const count = Number(root.dataset.cartCount) || 0;

        document.querySelectorAll('a.header-cart').forEach((link) => {
          link.setAttribute('aria-label', root.dataset.bagLabel + ': ' + count);
          link.setAttribute('aria-haspopup', 'dialog');
          link.setAttribute('aria-controls', 'VJCartDrawer');
          link.setAttribute('aria-expanded', String(Boolean(this.dialog?.open)));

          let badge = link.querySelector('.header-cart-count');

          if (count > 0) {
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'header-cart-count';
              link.append(badge);
            }

            badge.textContent = String(count);
          } else {
            badge?.remove();
          }
        });
      }

      open(trigger) {
        this.sync();

        const dialog = this.dialog;
        if (!dialog || dialog.open) return;

        this.opener = trigger || document.activeElement;
        dialog.showModal();
        this.syncHeader();
      }

      close() {
        this.dialog?.close();
      }

      announce(message, isError = false) {
        const element = this.root?.querySelector('[data-vj-cart-message]');
        if (!element) return;

        element.textContent = message;
        element.hidden = !message;
        element.classList.toggle('is-error', isError);
        element.setAttribute('role', isError ? 'alert' : 'status');
      }

      setBusy(value) {
        this.busy = value;

        const root = this.root;
        if (!root) return;

        root.setAttribute('aria-busy', String(value));

        root.querySelectorAll('[data-vj-change], [data-vj-cart-checkout]').forEach((control) => {
          if (value) {
            if (!control.hasAttribute('data-vj-was-disabled')) {
              control.dataset.vjWasDisabled = String(control.disabled);
            }

            control.disabled = true;
          } else if (control.hasAttribute('data-vj-was-disabled')) {
            control.disabled = control.dataset.vjWasDisabled === 'true';
            delete control.dataset.vjWasDisabled;
          }
        });

        root.querySelectorAll('[data-vj-cart-wallets]').forEach((wallets) => {
          wallets.toggleAttribute('inert', value);
        });

        if (!value && this.pendingFocusKey != null) {
          if (this.dialog?.open) {
            const candidates = root.querySelectorAll('[data-vj-focus-key]');

            const target = Array.from(candidates).find(
              (node) => node.dataset.vjFocusKey === this.pendingFocusKey
            );

            (target || root.querySelector('[data-vj-cart-close]'))?.focus({
              preventScroll: true
            });
          }

          this.pendingFocusKey = null;
        }
      }

      messageFrom(payload) {
        if (typeof payload?.description === 'string') return payload.description;
        if (typeof payload?.message === 'string') return payload.message;

        return this.root?.dataset.error || '';
      }

      applySection(html) {
        if (typeof html !== 'string' || !html.trim()) return false;

        const documentCopy = new DOMParser().parseFromString(html, 'text/html');
        const incoming = documentCopy.querySelector('[data-vj-cart-root]');
        const surface = this.root?.querySelector('[data-vj-cart-surface]');
        const incomingSurface = incoming?.querySelector('[data-vj-cart-surface]');

        if (!surface || !incomingSurface) return false;

        const focused = this.dialog?.contains(document.activeElement);
        const focusKey = document.activeElement?.getAttribute('data-vj-focus-key');

        const scrollTop =
          this.root.querySelector('[data-vj-cart-items]')?.scrollTop || 0;

        surface.replaceWith(incomingSurface);
        this.root.dataset.cartCount = incoming.dataset.cartCount;

        const items = this.root.querySelector('[data-vj-cart-items]');
        if (items) items.scrollTop = scrollTop;

        this.syncHeader();

        if (this.busy) this.setBusy(true);

        if (focused && this.dialog?.open) {
          const candidates = this.root.querySelectorAll('[data-vj-focus-key]');

          const target = Array.from(candidates).find(
            (node) => node.dataset.vjFocusKey === focusKey
          );

          if (this.busy) {
            this.pendingFocusKey = focusKey || 'close';
          } else {
            (target || this.root.querySelector('[data-vj-cart-close]'))?.focus({
              preventScroll: true
            });
          }
        }

        return true;
      }

      async refresh() {
        const root = this.root;
        if (!root) return false;

        const url = new URL(window.location.href);
        url.searchParams.set('sections', root.dataset.sectionId);

        const response = await fetch(url.toString(), {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store'
        });

        if (!response.ok) return false;

        const sections = await response.json();

        return this.applySection(sections[root.dataset.sectionId]);
      }

      async reconcile(payload) {
        const id = this.root?.dataset.sectionId;

        if (id && this.applySection(payload?.sections?.[id])) return true;

        return this.refresh();
      }

      async onSubmit(event) {
        const form = event.target;

        if (
          !(form instanceof HTMLFormElement) ||
          event.defaultPrevented ||
          !this.available
        ) return;

        const action = new URL(form.action, window.location.href);

        if (!action.pathname.replace(/\/$/, '').endsWith('/cart/add')) return;

        if (
          event.submitter &&
          !event.submitter.matches('[name="add"], [data-add-to-cart]')
        ) return;

        event.preventDefault();

        if (this.busy) return;

        const data = new FormData(form);

        data.set('sections', this.root.dataset.sectionId);
        data.set(
          'sections_url',
          window.location.pathname + window.location.search
        );

        const controls = Array.from(
          form.querySelectorAll(
            'button, input:not([type="hidden"]), select, textarea'
          )
        ).map((control) => ({
          control,
          disabled: control.disabled
        }));

        const productWallets = form.querySelector('.dynamic-checkout');
        const walletsWereInert = Boolean(
          productWallets?.hasAttribute('inert')
        );

        this.open(event.submitter || document.activeElement);
        this.setBusy(true);
        this.announce(this.root.dataset.adding);

        controls.forEach(({ control }) => {
          control.disabled = true;
        });

        productWallets?.setAttribute('inert', '');

        try {
          const response = await fetch(this.endpoint('cart/add.js'), {
            method: 'POST',
            body: data,
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            credentials: 'same-origin'
          });

          const payload = await response.json();

          if (!response.ok || payload.status) {
            const error = new Error(this.messageFrom(payload));
            error.cartMessage = this.messageFrom(payload);
            throw error;
          }

          if (!(await this.reconcile(payload))) {
            window.location.assign(this.cartUrl);
            return;
          }

          this.announce(this.root.dataset.added);
        } catch (error) {
          await this.refresh().catch(() => {});

          this.announce(
            error.cartMessage || this.root.dataset.error,
            true
          );
        } finally {
          this.setBusy(false);

          controls.forEach(({ control, disabled }) => {
            if (control.isConnected) control.disabled = disabled;
          });

          if (productWallets && !walletsWereInert) {
            productWallets.removeAttribute('inert');
          }

          if (
            !this.dialog?.open &&
            document.activeElement === document.body &&
            this.opener?.isConnected
          ) {
            this.opener.focus({ preventScroll: true });
          }
        }
      }

      async change(button) {
        if (this.busy) return;

        const quantity = Number(button.dataset.quantity);

        if (!Number.isInteger(quantity) || quantity < 0) return;

        const key = button.dataset.key;
        if (!key) return;

        this.setBusy(true);
        this.announce(this.root.dataset.updating);

        try {
          const response = await fetch(this.endpoint('cart/change.js'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({
              id: key,
              quantity: quantity,
              sections: [this.root.dataset.sectionId],
              sections_url:
                window.location.pathname + window.location.search
            })
          });

          const payload = await response.json();

          if (!response.ok || payload.status) {
            const error = new Error(this.messageFrom(payload));
            error.cartMessage = this.messageFrom(payload);
            throw error;
          }

          if (!(await this.reconcile(payload))) {
            throw new Error(this.root.dataset.error);
          }

          this.announce('');
        } catch (error) {
          await this.refresh().catch(() => {});

          this.announce(
            error.cartMessage || this.root.dataset.error,
            true
          );
        } finally {
          this.setBusy(false);
        }
      }

      async showBag(trigger) {
        this.open(trigger);

        if (this.busy) return;

        this.setBusy(true);
        this.announce(this.root.dataset.loading);

        try {
          if (!(await this.refresh())) {
            throw new Error(this.root.dataset.error);
          }

          this.announce('');
        } catch (error) {
          this.announce(this.root.dataset.error, true);
        } finally {
          this.setBusy(false);
        }
      }

      onClick(event) {
        if (
          !(event.target instanceof Element) ||
          !this.available
        ) return;

        const close = event.target.closest('[data-vj-cart-close]');

        if (close) {
          event.preventDefault();
          this.close();
          return;
        }

        const change = event.target.closest('[data-vj-change]');

        if (change && this.root.contains(change)) {
          event.preventDefault();
          this.change(change);
          return;
        }

        const trigger = event.target.closest('a.header-cart');

        if (
          !trigger ||
          event.defaultPrevented ||
          event.button > 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey ||
          trigger.target === '_blank'
        ) return;

        event.preventDefault();
        this.showBag(trigger);
      }
    }

    window.vjCartDrawerController = new VjCartDrawerController();
  }

  } catch(e) { console.error(e); }
})();
})();
